/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import PersonIcon from '@material-ui/icons/Person'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SettingsIcon from '@material-ui/icons/Settings'
import RecentActorsIcon from '@material-ui/icons/RecentActors'
import EventIcon from '@material-ui/icons/Event'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import DialpadIcon from '@material-ui/icons/Dialpad'
import AssessmentIcon from '@material-ui/icons/Assessment'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import InputIcon from '@material-ui/icons/Input'
import BusinessIcon from '@material-ui/icons/Business'
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import {FormattedMessage} from "react-intl"
import __ from "src/admin-utils/LanguageHelper"

export default [
  {
    subheader: __('الادارة', 'Management'),
    items: [
      {
        title: __('طلبات الصيانة', 'Maintenance Orders'),
        href: '/maintenance/orders',
        icon: BusinessCenterIcon
      },
      {
        title: __('طلبات قطع الغيار', 'Spare Orders'),
        href: '/spare/orders',
        icon: SettingsApplicationsIcon
      },
      {
        title: __('شهادات الانجاز', 'Achievement Certificates'),
        href: '/achievement/certificates',
        icon: CheckBoxIcon
      },
      {
        title: __('عروض الاسعار', 'Quotations'),
        href: '/quotations',
        icon: LocalAtmIcon
      },
      {
        title: __('الصيانة الدورية', 'Periodic Maintenance'),
        href: '/periodic/maintenance',
        icon: EventIcon
      },
      {
        title: __('الملفات', 'Files'),
        href: '/files',
        icon: AttachFileIcon
      },
      // {
      //   title: __('المخزون', 'Inventory'),
      //   href: '/inventory',
      //   icon: BusinessIcon
      // },
      // {
      //   title: __('الجرد', 'Inventory Records'),
      //   href: '/inventory/records',
      //   icon: ListAltIcon
      // },
    ]
  },
  // {
  //   // subheader: __('التقارير', 'Reports'),
  //   items: [
  //     {
  //       title: __('التقارير', 'Reports'),
  //       href: '/reports',
  //       icon: AssessmentIcon,
  //       items:[
  //         {
  //           title: __('الطلبات', 'Orders'),
  //           href: '/reports/orders',
  //         },
  //         {
  //           title: __('مشاهد الصيانة', 'Maintenance Orders'),
  //           href: '/reports/maintenance/orders',
  //         },
  //         {
  //           title: __('طلبات التسعير لقطع الغيار', 'Quotations'),
  //           href: '/reports/quotations',
  //         },
  //         {
  //           title: __('مشاهد الصيانة الدورية', 'periodic Maintenance Orders'),
  //           href: '/reports/periodic/maintenance',
  //         },
  //         {
  //           title: __('شهادات الانجاز', 'Achievement Certificates'),
  //           href: '/reports/achievement/certificates',
  //         },
  //       ]
  //     },
  //   ]
  // },
  {
    subheader: __('الاعدادات', 'Settings'),
    items: [
      {
        title: __('المناطق', 'Regions'),
        href: '/settings/regions',
        icon: ListAltIcon
      },
      {
        title: __('المواقع', 'Sites'),
        href: '/settings/sites',
        icon: ListAltIcon
      },
      {
        title: __('الوحدات', 'Units'),
        href: '/settings/units',
        icon: ListAltIcon
      },
      {
        title: __('بيانات الشهادة', 'Certificate Items'),
        href: '/settings/certificate/items',
        icon: ListAltIcon
      },
      // {
      //   title: __('اصناف المخزون', 'Inventory Items'),
      //   href: '/settings/inventory/items',
      // },
      {
        title: __('اقسام الملفات', 'File Categories'),
        href: '/settings/categories',
        icon: ListAltIcon
      },
      {
        title: __('الصيانة الدورية', 'Periodic Items'),
        href: '/settings/periodic/items',
        icon: ListAltIcon
      },
    ]
  },
  {
    subheader: __('لوحة تحكم الفني', 'Employee Dashboard'),
    items: [
      {
        title: __('طلبات الصيانة', 'Maintenance Orders'),
        href: '/employee/maintenance/orders',
        icon: BusinessCenterIcon
      },
      {
        title: __('الصيانة الدورية', 'Periodic Maintenance'),
        href: '/employee/periodic/maintenance',
        icon: EventIcon
      },
      {
        title: __('طلبات قطع الغيار', 'Spare Orders'),
        href: '/employee/spare/orders',
        icon: SettingsApplicationsIcon
      },
    ]
  },
  {
    subheader: __('لوحة تحكم ضابط المنطقة', 'Officer Dashboard'),
    items: [
      {
        title: __('طلبات الصيانة', 'Maintenance Orders'),
        href: '/officer/maintenance/orders',
        icon: BusinessCenterIcon
      },
      // {
      //   title: __('طلبات قطع الغيار', 'Spare Orders'),
      //   href: '/officer/spare/orders',
      //   icon: SettingsApplicationsIcon
      // },
      {
        title: __('شهادات الانجاز', 'Achievement Certificates'),
        href: '/officer/achievement/certificates',
        icon: CheckBoxIcon,
      },
      {
        title: __('الصيانة الدورية', 'Periodic Maintenance'),
        href: '/officer/periodic/maintenance',
        icon: EventIcon
      },
      {
        title: __('المخزون', 'Inventory'),
        href: '/officer/inventory',
        icon: BusinessIcon
      },
      {
        title: __('حركة المخزون', 'Inventory History'),
        href: '/officer/inventory/records',
        icon: ListAltIcon
      },
      {
        title: __('التوقيع', 'Signature'),
        href: '/officer/signature',
        icon: ListAltIcon
      },
      // {
      //   title: __('اصناف المخزون', 'Inventory Items'),
      //   href: '/officer/inventory/items',
      //   icon: ListAltIcon
      // },
    ]
  },
  {
    subheader: __('لوحة تحكم مشرف المشروع', 'Supervisor Dashboard'),
    items: [
      {
        title: __('طلبات الصيانة', 'Maintenance Orders'),
        href: '/supervisor/maintenance/orders',
        icon: BusinessCenterIcon
      },
      {
        title: __('طلبات قطع الغيار', 'Spare Orders'),
        href: '/supervisor/spare/orders',
        icon: SettingsApplicationsIcon
      },
      {
        title: __('شهادات الانجاز', 'Achievement Certificates'),
        href: '/supervisor/achievement/certificates',
        icon: CheckBoxIcon,
      },
      {
        title: __('الصيانة الدورية', 'Periodic Maintenance'),
        href: '/supervisor/periodic/maintenance',
        icon: EventIcon
      },
      {
        title: __('المخزون', 'Inventory'),
        href: '/supervisor/inventory',
        icon: BusinessIcon
      },
      {
        title: __('حركة المخزون', 'Inventory History'),
        href: '/supervisor/inventory/records',
        icon: ListAltIcon
      },
      {
        title: __('الملفات', 'Files'),
        href: '/supervisor/files',
        icon: AttachFileIcon
      },
      {
        title: __('التوقيع', 'Signature'),
        href: '/supervisor/signature',
        icon: ListAltIcon
      },
    ]
  },
  {
    subheader: __('ادارة المستخدمين', 'User Management'),
    items: [
      {
        title: __('الادوار', 'Roles'),
        href: '/user/management/roles',
        icon: RecentActorsIcon,
      },
      {
        title: __('الاعضاء', 'Users'),
        href: '/user/management/users',
        icon: AssignmentIndIcon,
      },
    ]
  },
  {
    items: [
      {
        title: __('تسجيل الخروج', 'Log Out'),
        href: '/auth/login',
        icon: InputIcon,
        alwaysShow: true
      },
    ]
  },
]
